"use client";

import { useLocale } from "use-intl";

import { GlobeIcon } from "@/components/appIcons";

import { CountryChipIcon, FilterChip, countryChipLabel } from "./filter-chip";
import { SearchMusicFilterChips } from "./search-music-filter-chips";
import type { SearchFilters } from "./use-search-state";

export function SearchActiveFilterChips({
  filters,
  hasFilters,
  music,
  updateFilter,
  updateFilters,
  setFilter,
}: {
  filters: SearchFilters;
  hasFilters: boolean;
  music: boolean;
  updateFilter: (key: string, value: string | number | boolean | undefined) => void;
  updateFilters: (updates: Record<string, string | number | undefined>) => void;
  setFilter: (key: "label" | "company", value: string[] | undefined) => void;
}) {
  const locale = useLocale();
  if (!hasFilters) return null;
  return (
    <div className="mb-4 flex gap-2 overflow-x-auto pb-1 no-scrollbar">
      {filters.country && (
        <FilterChip
          iconSlot={<CountryChipIcon code={filters.country} fallbackIcon={GlobeIcon} />}
          onClear={() => updateFilter("country", undefined)}
        >
          {countryChipLabel(filters.country, locale)}
        </FilterChip>
      )}
      {music && (
        <SearchMusicFilterChips
          filters={filters}
          updateFilter={updateFilter}
          updateFilters={updateFilters}
          setFilter={setFilter}
        />
      )}
    </div>
  );
}
